var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 49,
    viewBox: "0 0 32 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.317 13.7588V13.6296C31.317 5.19225 24.6312 0 15.0914 0C9.5885 0 5.21394 1.55143 1.70971 3.95341C-0.327379 5.34949 -0.510771 8.4102 0.981651 10.3799L2.06996 11.8162C3.56238 13.785 6.2348 13.9722 8.39817 12.7772C10.3697 11.688 12.3693 11.0985 14.2474 11.0985C17.3625 11.0985 19.115 12.4608 19.115 14.6682V14.7327C19.115 17.524 16.4538 21.5129 8.92512 22.1615L8.66586 22.4534C8.52273 22.6144 8.70336 24.7264 9.06825 27.1695L9.36777 29.1617C9.73266 31.6048 11.7875 33.5847 13.9557 33.5847C16.1238 33.5847 18.0569 32.6547 18.2703 31.5084C18.4864 30.3613 18.6605 29.4311 18.6605 29.4311C25.8635 27.6777 31.317 21.937 31.317 13.7588ZM11.8399 37.3484C9.36966 37.3484 7.36818 39.3509 7.36818 41.8212V43.9097C7.36818 46.38 9.3707 48.3825 11.8399 48.3825H15.6802C18.1504 48.3825 20.1529 46.38 20.1529 43.9097V41.8212C20.1529 39.3509 18.1496 37.3484 15.6802 37.3484H11.8399Z",
    fill: "#3279E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.cdf15b06848f5e4bf33ed49e9de56358.svg";
export { ForwardRef as ReactComponent };